import React from "react";
import { string, object } from "prop-types";
import cx from "classnames";

import ImageElement from "../ImageElement/ImageElement.jsx";

const propTypes = {
  orientation: string,
  description: string,
  source: string,
  altClass: string,
  image: object,
  title: string, // only used in StoryBuilder component
};

const ImageBlock = (props) => {
  const { orientation, description, source, altClass, image, title } = props;

  return (
    <section
      className={cx("component image-block", orientation, {
        [`${altClass}`]: altClass,
      })}
    >
      <figure className="image-block__media">
        <ImageElement {...image} />
        {(title || description || source) && (
          <figcaption className="image-block__caption">
            {title && (
              <h2 className="image-block__title txt-heading-b">{title}</h2>
            )}
            {description && (
              <span className="image-block__description">{description}</span>
            )}
            {source && <span className="image-block__source">{source}</span>}
          </figcaption>
        )}
      </figure>
    </section>
  );
};

ImageBlock.propTypes = propTypes;
export default ImageBlock;
